import { ViewCustomer } from "collins-js-sdk";
import React, { createContext, useMemo, useState, ReactNode } from "react";

type CustomerContextType = {
  allCustomers?: ViewCustomer[];
  setAllCustomers: React.Dispatch<ViewCustomer[] | undefined>;
  selectedCustomer?: ViewCustomer;
  setSelectedCustomer: React.Dispatch<ViewCustomer | undefined>;
};

export const CustomerContext = createContext<CustomerContextType>({
  allCustomers: undefined,
  setAllCustomers: () => true,
  selectedCustomer: undefined,
  setSelectedCustomer: () => true
});

export const CustomerContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [allCustomers, setAllCustomers] = useState<ViewCustomer[]>();
  const [selectedCustomer, setSelectedCustomer] = useState<ViewCustomer>();

  const contextValue = useMemo(
    () => ({
      allCustomers,
      setAllCustomers,
      selectedCustomer,
      setSelectedCustomer
    }),
    [allCustomers, selectedCustomer]
  );

  return (
    <CustomerContext.Provider value={contextValue}>
      {children}
    </CustomerContext.Provider>
  );
};
